const _excluded = ["user", "theme"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { useDeprecate } from '@adsk/alloy-react-helpers';
import Avatar from './Avatar';
const Themes = {
  DARK: Avatar.COLORS.COLOR_7,
  LIGHT: Avatar.COLORS.COLOR_1
};
const AvatarAdapter = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      user,
      theme = Themes.LIGHT
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  useDeprecate(true, '@adsk/alloy-react-avatar', 'AvatarAdapter', 'Avatar');
  return /*#__PURE__*/React.createElement(Avatar, _extends({
    ref: ref,
    name: user.name,
    image: user.profileImg50,
    color: theme
  }, props));
});
AvatarAdapter.displayName = 'AvatarAdapter';
AvatarAdapter.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
    profileImg50: PropTypes.string
  }).isRequired,
  theme: PropTypes.oneOf(Object.values(Themes))
};
export default Object.assign(AvatarAdapter, {
  Themes
});
//# sourceMappingURL=AvatarAdapter.js.map